<template style="">
  <div class="propagate_index">
    <el-row style="padding: 10px;">
      <el-button type="primary" @click="Article_release()"> + 文章</el-button>
      <el-button type="primary" @click="Video_release()"> + 视频</el-button>
      <el-button type="primary" @click="Audio_release()"> + 音频</el-button>
      <!-- <el-button type="primary" @click="Picture_release(1)"> + 图片发布</el-button> -->
      <el-button type="primary" @click="Picture_release(2)"> + 轮播图</el-button>
      <el-button type="primary" @click="gonggao()"> + 公告</el-button>
      <!-- <el-button type="primary" @click="Sign_in()"> + 测试</el-button> -->
    </el-row>

    <el-form style="padding: 10px;" :inline="true" class="demo-form-inline" >

      <el-form-item label="标题">
        <el-input v-model="Name" placeholder="请输入标题查询"></el-input>
      </el-form-item>

      <el-form-item label="发布日期">
        <el-date-picker v-model="StartTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable = false></el-date-picker>
      </el-form-item>

      <el-form-item label="发布状态">
        <el-select v-model="Status" placeholder="发布状态">
          <el-option label="全部"      value=""></el-option> 
          <el-option label="正在审核"  value="6"></el-option> 
          <el-option label="已驳回"    value="3"></el-option>
          <el-option label="已通过"    value="2"></el-option>
          <el-option label="已发布"    value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="内容形式">
        <el-select v-model="MaterialType" placeholder="内容形式">
          <el-option label="全部" value=""></el-option>
          <el-option label="文章" value="1"></el-option>
          <el-option label="视频" value="4"></el-option>
          <el-option label="音频" value="3"></el-option>
          <!-- <el-option label="图片" value="2"></el-option> -->
          <el-option label="公告" value="8"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="栏目">
        <el-cascader ref="wcascader" v-model="ItemName" @change="Selected_to_shut_dow" :options="datass" :props="{ checkStrictly: true }" clearable placeholder="请选择上级栏目"></el-cascader>

        <!-- <el-select v-model="ItemName" placeholder="栏目">
             <el-option label="全部" value=""></el-option>
             <el-option label="咨询" value="1"></el-option>
             <el-option label="测评" value="2"></el-option>
             <el-option label="活动" value="3"></el-option>
             <el-option label="科普" value="4"></el-option>
        </el-select> -->

      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="resetfun()">重置</el-button>
        <el-button type="primary" @click="derive()">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" stripe style="width: 96%;margin-left: 2%;margin-top: 20px;" v-loading="Pageloading">
      <el-table-column prop="materialName" label="标题" width="180"></el-table-column>
      <el-table-column prop="materialType" label="内容形式" width="180"></el-table-column>
      <el-table-column prop="itemName"     label="栏目"></el-table-column>
      <el-table-column prop="status"       label="发布状态"></el-table-column>
      <el-table-column prop="creator"      label="编辑人账号"></el-table-column>
      <el-table-column prop="realName"      label="编辑人姓名"></el-table-column>
      <el-table-column prop="createdDate"  label="创建时间"></el-table-column>
      <el-table-column prop="scheduledRelease"  label="定时时间"></el-table-column>
      <!-- <el-table-column label="是否启用">
        <template slot-scope="scope">
          {{ scope.row.isActive==1?'是':'否' }}
        </template>
      </el-table-column> -->

      <el-table-column label="操作">
        <template slot-scope="scope">
          <span style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" v-if="scope.row.status == '草稿' || scope.row.status == '已驳回' || scope.row.status == '正在审核'" @click="re_edit(scope.row.materialKey, scope.row.materialType,1)">重新编辑</span>
          <span style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="re_look(scope.row.materialKey, scope.row.materialType,scope.row.status)">{{scope.row.status == '已驳回'?'驳回原因':'查看'}}</span>
          <!-- <span style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="Preview(scope.row.materialKey)" v-if="scope.row.materialType=='文章' || scope.row.materialType=='公告'">预览</span> -->
          <!-- <span style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" v-if="scope.row.status == '已通过'" @click="re_publish(scope.row.materialKey)">发布</span> -->
          <!-- <span style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);"  @click="del(scope.row.materialKey)">删除</span> -->
          <el-popconfirm title="是否删除该条记录？" @confirm="del(scope.row.materialKey)">
                                <el-button slot="reference" type="text"  style="margin-left: 10px;color: #1F34F5;">删除</el-button>
                            </el-popconfirm>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination style="margin-top:20px;" @current-change="handleCurrentChange" :current-page.sync="PageIndex" :page-size="10" layout="total, prev, pager, next" :total="Count" v-if="Count > 0"></el-pagination>

    <el-dialog :visible.sync="dialogVisible" width="640px" top="10vh" :before-close="handleClose">
      <div class="Articlecontent">
        <div v-html="Article"></div>
      </div>
      <div v-if="url">
        附件
        {{url.toString()}}
      </div>
    </el-dialog>
    
  </div>
</template>
<script>
export default {
  data() {
    return {
      Pageloading:false,
      Name:'',//内容编号、标题
      Status:'',//发布状态  1、已发布； 2、已通过； 3、已驳回； 4、需修订； 5、草稿； 6、正在审核
      StartTime:'',//开始发布时间
      MaterialType:'',//内容形式  1、文章， 2、图片， 3、音乐， 4、视频
      ItemName: '',//栏目 1、咨询 2、测评 3、活动 4、科普
      tableData: [],
      PageIndex: 1,
      PageSize: 10,
      Count: 1,
      dialogVisible:false,
      Article:'',
      url:[],
      datass:[],
    }
  },
  mounted() {

    this.$Http_Post('management/getColumnManagementByNode', { PItemKey: '0', pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.datass = res.Data
      } else {
        this.Global.request_failure(res.Message);
      }
    })

    this.loading();

  },
  methods: {
    Selected_to_shut_dow(dt) {
      this.ItemName = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    derive(){
      this.$Http_Post('management/getContentDistribution', { Name: this.Name, PageIndex: this.PageIndex, PageSize: this.PageSize, Status:this.Status , MaterialType: this.MaterialType , ItemName: this.ItemName , StartTime: this.StartTime[0] , EndTime: this.StartTime[1],RoleID:sessionStorage.getItem('RoleID'),ExcelFlag:'1' }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.href = res.Data;
        }
      });
    },
    del(materialKey){
      this.$Http_Post('management/materialDel', { MaterialKey : materialKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          // 删除成功后检查当前页是否还有数据
          const currentPageDataCount = this.tableData.length;          
          // 如果当前页只有一条数据，且不是第一页，则跳转到上一页
          if (currentPageDataCount === 1 && this.PageIndex > 1) {
            this.PageIndex = this.PageIndex - 1;
          }

          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
      })

    },
    resetfun() {
      this.Name = '';
      this.Status = '';
      this.StartTime = '';
      this.MaterialType = '';
      this.ItemName = '';
      this.tableData = [];
      this.PageIndex = 1;
      this.PageSize = 10;
      this.loading();
    },
    re_publish(materialKey) {//发布
      this.$Http_Post('management/contentPublishOperate', {MaterialKey:materialKey,Type:1}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.loading();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    re_look(materialKey, materialType,status) {//查看
      if (materialType == "音频") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: {materialKey:materialKey,Type:1,Source:7,status:status},
        })
      } else if (materialType == "视频") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: {materialKey:materialKey,Type:2,Source:7,status:status},
        })
      } else if (materialType == "图片") {
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: {materialKey:materialKey,Type:3,Source:7,status:status},
        })
      }else if(materialType == "文章" || materialType == "公告"){
        this.$router.push({
          path: '/propagate/Propagate_look',
          query: {materialKey:materialKey,Type:4,Source:7,status:status},
        })
      }
    },

    // 预览
    Preview(materialKey){
      this.$Http_Post('management/getContentDetails',{MaterialKey:materialKey}).then(res=>{
        if(res.Code==200 || res.Code==0){
          this.dialogVisible=true;
          this.url = res.Data.materialPaths
          this.Article=res.Data.richTextContent
        }else{
          this.$message({type: 'error', message:res.Message});
        }
      });
    },

    re_edit(materialKey, materialType) {//重新编辑

      if (materialType == "音频") {
        this.$router.push({
          path: '/propagate/Audio_release',
          query: { materialKey: materialKey },
        })
      } else if (materialType == "视频") {
        this.$router.push({
          path: '/propagate/Video_edit',
          query: { materialKey: materialKey },
        })
      } else if (materialType == "图片") {
        this.$router.push({
          path: '/propagate/Picture_edit',
          query: { materialKey: materialKey },
        })
      } else if (materialType == "文章") {
        this.$router.push({
          path: '/propagate/Article_release',
          query: { materialKey: materialKey },
        })
      }else if(materialType == "公告"){
        // alert(1)
        this.$router.push({
          path: '/propagate/Article_releasesedit',
          query: { materialKey: materialKey },
        })

      }



    },
    Sign_in() {
      this.$router.push({
        path: '/Data/All_data',
      })
      // window.location.href = "Sign_in.html";
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.loading();
      //分页点击
    },
    Article_release() {//文章发布
      this.$router.push({
        path: '/propagate/Article_release',
        // query: { PaperID: row.PaperID, PublishID: row.PublishID },
      })
    },
    gonggao() {//公告发布
      this.$router.push({
        path: '/propagate/Article_releases',
        // query: { PaperID: row.PaperID, PublishID: row.PublishID },
      })
    },
    Video_release() {//视频发布
      this.$router.push({
        path: '/propagate/Video_release',
        // query: { PaperID: row.PaperID, PublishID: row.PublishID },
      })
    },
    Audio_release() {//音频发布
      this.$router.push({
        path: '/propagate/Audio_release',
        // query: { PaperID: row.PaperID, PublishID: row.PublishID },
      })
    },
    Picture_release(val) {//音频发布
      if(val == 2){
        this.$router.push({
          path: '/propagate/app_management',
          // query: { PaperID: row.PaperID, PublishID: row.PublishID },
        })
      }else{
        this.$router.push({
          path: '/propagate/Picture_release',
          // query: { PaperID: row.PaperID, PublishID: row.PublishID },
        })
      }
      
    },
    loading() {
      this.Pageloading=true;
      this.$Http_Post('management/getContentDistribution', { Name: this.Name, PageIndex: this.PageIndex, PageSize: this.PageSize, Status:this.Status , MaterialType: this.MaterialType , ItemName: this.ItemName , StartTime: this.StartTime[0] , EndTime: this.StartTime[1],RoleID:sessionStorage.getItem('RoleID'),ExcelFlag:'0' }).then((res) => {
       this.Pageloading=false;
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.Count = Number(res.Counts);
        }
      });
    },
    onSubmit() {//搜索
      this.PageIndex = 1
      this.loading()
    },
    handleClose(done){
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    }
  },
}
</script>
<style>
  .propagate_index{background-color: #fff;height: 100%;width: 100%;overflow: auto;}
  .el-table--enable-row-transition .el-table__body td{text-align: center;}
  .Articlecontent{padding: 30px;height: 70vh;overflow-y: auto;}
</style>
